import "../../../libs/tonejs/Midi.js";

import { Stage } from "../display/Stage.js";
import { TabBar } from "../display/TabBar.js";
import { Data } from "../model/Data.js";
import { VOMelody } from "../model/DataStructure.js";

export interface MidiAppOptions {
    element: HTMLDivElement;
    restUrl: string;
}

interface MidiNote {
    name: string;
    time: number;
    dur: number;
    velocity: number;
}

export class MidiApp {

    private _element: HTMLDivElement;
    private _stage: Stage;
    private _options: MidiAppOptions;
    private _data: Data;
    private _box: HTMLElement;

    constructor(options: MidiAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        this._stage = new Stage({
            element: this._element,
            className: "midi-app",
            layout: "responsive"
        });

        try {
            this._data = new Data();

            await this._data.load(this._element.getAttribute("data-data"));


            const box = document.createElement("div");
            box.className = "midi-app__box e5-hidden";
            this._stage.content.appendChild(box);
            this._box = box;

            var bar = new TabBar<VOMelody>({
                container: this._stage.content,
                direction: "vertical",
            });
            bar.onSelect.once(() => {
                this._box.classList.remove("e5-hidden");
            });

            const melodies = this._data.data.phil_melody.slice();
            melodies.sort((a, b) => a.title.localeCompare(b.title));
            for (let melody of melodies) {
                bar.add({
                    data: melody,
                    label: melody.title
                });
            }
            // bar.current = melodies[0];

            const file = document.createElement("input");
            file.className = "midi-app__input";
            box.appendChild(file);
            file.type = "file";
            file.onchange = async (e) => {

                if (!bar.current) {
                    return;
                }

                let f = file.files[0];

                var midiFile = await MidiLoader.fromUrl(window.URL.createObjectURL(f));

                const dudes = midiFile.tracks[0].notes;
                let lastTime = dudes[0].time;
                const notes: MidiNote[] = dudes.map((item: any) => {
                    let t = item.time;
                    t = t - lastTime;
                    lastTime = item.time;
                    return {
                        name: item.name,
                        velocity: item.velocity.toFixed(4),
                        dur: item.duration.toFixed(4),
                        time: t.toFixed(4)
                    };
                });
                // console.log(bar.current.id, bar.current.title, notes);

                file.value = null;

                this.submit(bar.current.id, notes);
            }

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }

    private _submitting: boolean = false;
    private async submit(melodyId: number, notes: MidiNote[]) {
        if (this._submitting) {
            return;
        }
        this._submitting = true;
        const response: any = await e5.load(
            "json",
            this._options.restUrl,
            {
                data: {
                    data: {
                        melody_id: melodyId,
                        notes: notes
                    }
                }
            }
        );

        if (response?.kind === 'success') {
            console.log("RESPONSE", response);
            e5.Toast.showText("Melodie Noten wurde gespeichert!");
        } else {
            console.log("RESPONSE", response);
            e5.Toast.showText("Leider ist etwas schief gelaufen.");
        }

        this._submitting = false;
    }
}